/**
 * The Knowledge module's shell wrapper — one AppShell around the whole
 * /knowledge/* subtree (pages elsewhere each wrap themselves; a subtree
 * router wraps once). Nav inside AppShell is scope-aware: a member holding
 * only KnowledgeBase.* sees the Knowledge section and nothing else.
 */
import { AppShell } from '../../components/AppShell.js';
import { KnowledgeRoutes } from './KnowledgeRoutes.js';

export const KnowledgeArea = () => (
  <AppShell>
    <KnowledgeRoutes />
  </AppShell>
);
